
function Header()
{
    return (
        <div className="header">
            <div className="header__wrapper">
                <div className="main">
                    <div className="main__wrapper">
                        <h1>
                            <a href="https://info.castlegateit.co.uk" className="logo_link">
                                <img src="/cgit-logo.png" alt=""/>
                            </a>
                        </h1>
                    </div>
                    <div className="main__wrapper main__wrapper--flex-end">
                        <h2>
                            Support details
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;